import React, { useContext, useEffect } from 'react';
import cl from './List.module.css';
import { AppContext } from "../../../../providers/appProvider";
import ErrorModal from '../../../UI/ErrorModal/ErrorModal';
import Pagination from '../../../UI/Pagination/Pagination'; 
import { useInvoice } from '../../../../hooks/useInvoice';
import Invoice from './Invoice';
import { useTranslation } from 'react-i18next'; 

const List = () => { 
  const { t, i18n } = useTranslation();
  const lang = i18n.language;     

  const { appState, app } = useContext(AppContext);
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString); 
    const months = [t('Jan'), t('Feb'), t('Mar'), t('Apr'), t('May'), t('Jun'), t('Jul'), t('Aug'), t('Sep'), t('Oct'), t('Nov'), t('Dec')];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${day} ${month} ${year} ${hours}:${minutes}`;
  }; 
  const { invoiceService } = useInvoice(50); 

  useEffect(() => {
    invoiceService.fetchList();
  }, []);

  return (
    
    <div>

    <div className={ cl.headMain }> 
        <h1>{t('Invoices')}</h1> 

        <div style={{ display: 'flex' , gap: '10px'}}>
 
        </div>
        
    </div>

    <div className={cl.cardContainer}>
      {invoiceService.items.map((item) => (
        <div key={item.id} className={`${cl.card} ${item.is_paid ? '' : cl.unpaidCard}`}>
          
          <div className={cl.cardHeader}>
             {item.is_paid && <span style={{ color: 'green' }}>✔</span>}
          </div>

          <div className={cl.cardBody}>
            <h2>{t('Invoice')}: N{item.id}</h2>

            <p><strong>{ 
      i18n.language === 'ka' ? 'დანიშნულება:' :
      i18n.language === 'ru' ? 'Назначение:' :
      'Purpose:'
    }</strong>  
    {
    i18n.language === 'ka' ? item.name :
    i18n.language === 'ru' ?
      item.name === 'გამოყოფილი სერვერი' ? 'Выделенный сервер' :
      item.name === 'საპორტი' ? 'Поддержка' : item.name :
    // English
      item.name === 'გამოყოფილი სერვერი' ? 'Dedicated Server' :
      item.name === 'საპორტი' ? 'Support' : item.name
  }
  
  </p>




            <p><strong>{ 
      i18n.language === 'ka' ? 'ინვოისის მიმღები:' :
      i18n.language === 'ru' ? 'Получатель счета:' :
      'Invoice recipient:'
    }</strong>  LTD AUTO IMPORT GEORGIA (406203120) </p>
            <p><strong>{ 
      i18n.language === 'ka' ? 'ინვოისის მიმწოდებელი:' :
      i18n.language === 'ru' ? 'Отправитель счета:' :
      'Invoice sender:'
    }</strong> Nika Potskhveria</p>
            <p><strong>{t('Amount')}:</strong> {item.amount} Gel</p>
            <p><strong>{t('CreatedAt')}:</strong> {formatDate(item.created_date)}</p>
            <p><strong>{t('Status')}:</strong> {item.is_paid ? <>{ 
      i18n.language === 'ka' ? 'გადახდილი' :
      i18n.language === 'ru' ? 'Оплаченный' :
      'Paid:'
    }</> :  <>{ 
      i18n.language === 'ka' ? 'გადაუხდელი' :
      i18n.language === 'ru' ? 'Неоплаченный' :
      'Unpaid'
    }</>}</p>

            <Invoice item={item}   />

          </div>
        </div>
      ))}
    </div>

      {appState.error && <ErrorModal Invoice={appState.error} onClose={() => app.clearError()} />}
      <Pagination
        total={invoiceService.total}
        perPage={invoiceService.filter.limit}
        current={invoiceService.filter.page}
        paginate={invoiceService.setFilter}
        setLimit={invoiceService.setFilter}
      />
    </div>
  );
}

export default List;
